import React from 'react';
import PropTypes from 'prop-types';
import { nike } from '@nike/nike-design-tokens';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { toTitleCase } from '../../util/toTitleCase';

import { productDivisionMapWithAge } from '../../shop/constants';

const ProductGenderDivision = ({ gender, division, sport, textColor, isHeader }) => {
  const normalizedGender = gender && productDivisionMapWithAge.get(gender);
  const normalizedDivision = division && productDivisionMapWithAge.get(division);
  return (
    <span style={{ wordBreak: 'keep-all' }} className={isHeader ? 'title-4' : 'body-4'}>
      {normalizedGender && (
        <span data-desc={`gridwall__productCard_gender_${normalizedGender}`} style={{ color: textColor }}>
          <TranslatedCopy id={`product.description.ageGender.${normalizedGender}`} />
        </span>
      )}
      {normalizedGender && ' '}
      {sport && (
        <span data-desc={`gridwall__productCard_sport_${toTitleCase(sport)}`} style={{ color: textColor }}>
          {`${toTitleCase(sport)} `}
        </span>
      )}
      {normalizedDivision && (
        <span data-desc={`gridwall__productCard_division_${normalizedDivision}`} style={{ color: textColor }}>
          <TranslatedCopy id={`product.description.division.${normalizedDivision}`} />
        </span>
      )}
    </span>
  );
};

ProductGenderDivision.defaultProps = {
  gender: null,
  division: null,
  sport: null,
  textColor: nike.podiumCdsColorBlack,
  isHeader: false
};

ProductGenderDivision.propTypes = {
  gender: PropTypes.string,
  division: PropTypes.string,
  sport: PropTypes.string,
  textColor: PropTypes.string,
  isHeader: PropTypes.bool
};
export default ProductGenderDivision;
